<template>
  <div class="top5-table__container">
    <div class="top5-table__toolbar">
      <span class="top5-table__title">Top 5 Suspicious Domains</span>
      <a href="#" class="top5-table__view-all" @click.prevent="$emit('viewAll')">View All</a>
    </div>

    <hr class="top5-table__divider" />

    <div class="scan-history-table-wrapper" style="overflow-x: auto;">
      <table class="table scan-history-table" style="margin: 0">
        <thead>
          <tr>
            <th>Domain</th>
            <th>Total Scan</th>
            <th>First Scan</th>
            <th>Location</th>
            <th>District</th>
            <th>Risk Score</th>
            <th>Domain Status</th>
            <th style="width: 160px;">Action</th>
          </tr>
        </thead>
        <!-- <tbody v-if="loading" class="top5-table__empty"> -->
        <tbody>
          <tr v-if="loading">
            <td colspan="8" class="text-center text-muted py-3" style="font-size: 13px">Loading...</td>
          </tr>
          <!-- </tbody> -->
          <template v-else>
            <tr v-for="(item, idx) in domains" :key="idx">
              <td class="domain-cell">{{ item.domain }}</td>
              <td>{{ numberWithCommas(item.totalScan) }}</td>
              <td>{{ item.firstScan }}</td>
              <td>{{ item.location }}</td>
              <td>{{ item.district }}</td>
              <td>
                <span class="top5-table__badge" :class="riskClass(item.riskScore)">
                  {{ capitalize(item.riskScore) }}
                </span>
              </td>
              <td>
                <span class="top5-table__badge" :class="statusClass(item.domainStatus)">
                  {{ statusLabel(item.domainStatus) }}
                </span>
              </td>
              <td>
                <div class="top5-table__actions">
                  <button v-if="isWatchlistable(item.domainStatus)" class="top5-table__btn top5-table__btn--watchlist"
                    @click="$emit('watchlist', item)">Watchlist</button>
                  <button class="top5-table__btn top5-table__btn--detail" @click="$emit('detail', item)">Detail</button>
                </div>
              </td>
            </tr>
            <tr v-if="!domains || !domains.length">
              <td colspan="8" class="text-center text-muted py-3" style="font-size: 13px;">No data available</td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DomainSummaryTop5Table',
  props: {
    domains: {
      // loading: false,
      type: Array,
      default: () => [],
      // each: { domain, totalScan, firstScan, location, district, riskScore, domainStatus }
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  // data() {
  //   return {
  //     items: [],
  //     loading: false,
  //   };
  // },
  // mounted() {
  //   this.fetchData();
  // },
  methods: {
    // async fetchData() {
    //   this.loading = true;
    //   try {
    //     const params = qs.stringify(
    //       {
    //         start_date: this.startDate,
    //         end_date: this.endDate,
    //         domain: this.domain,
    //         province: this.province,
    //         region: this.region,
    //         district: this.district,
    //       },
    //       { skipNulls: true },
    //     );
    //     const resp = await this.$http.get(`/api/domain-detection-summary/top-5-suspicious-domain-list?${params}`);
    //     this.items = resp.data.data.map((d) => ({
    //       domainId: d.domain_id,
    //       domain: d.domain_url,
    //       totalScan: d.total_scan,
    //       firstScan: d.first_scan.replace(" ", " | "),
    //       location: d.total_region,
    //       district: d.total_district,
    //       riskScore: d.risk_score,
    //       domainStatus: d.domain_status,
    //     }));
    //   } catch (e) {
    //     this.errorPrint(e);
    //     this.items = [];
    //   } finally {
    //     this.loading = false;
    //   }
    // },
    riskClass(score) {
      if (!score) return ''
      const s = score.toLowerCase()
      if (s === 'high') return 'top5-table__badge--high'
      if (s === 'medium') return 'top5-table__badge--medium'
      return 'top5-table__badge--low'
    },
    statusClass(status) {
      if (!status) return ''
      const s = status.toLowerCase().replace(/\s+/g, '-')
      if (s === 'under-review') return 'top5-table__badge--under-review'
      if (s === 'dismissed') return 'top5-table__badge--dismissed'
      if (s === 'watchlisted') return 'top5-table__badge--watchlisted'
      return ''
    },
    statusLabel(status) {
      if (!status) return ''
      return status.charAt(0).toUpperCase() + status.slice(1)
    },
    isWatchlistable(status) {
      if (!status) return true
      const s = status.toLowerCase()
      return s !== 'watchlisted' && s !== 'dismissed'
    },
  },
}
</script>

<style scoped>
.top5-table__container {
  display: flex;
  flex-direction: column;
  /* gap: 16px; */
  border-radius: 8px;
  padding: 16px;
  background: #ffffff;
}

.top5-table__toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.top5-table__title {
  font-size: 14px;
  font-weight: 600;
  color: #000;
}

.top5-table__view-all {
  font-size: 11px;
  color: #2196f3;
  text-decoration: underline;
}

.top5-table__divider {
  border: none;
  border-top: 1px solid #e0e0e0;
  margin: 0 0 12px;
}

.scan-history-table {
  font-family: 'Inter', sans-serif !important;
}

.scan-history-table thead th {
  font-family: 'Inter', sans-serif !important;
  font-weight: 400 !important;
  font-size: 12px !important;
  color: #4b4b4b !important;
  border-top: 1px solid #e6e6e6;
  white-space: nowrap;
  padding: 10px 8px;
}

.scan-history-table tbody td {
  font-family: 'Inter', sans-serif !important;
  font-weight: 400 !important;
  font-size: 12px !important;
  color: #393939 !important;
  border-bottom: 1px solid #e6e6e6 !important;
  border-top: none !important;
  vertical-align: middle;
  padding: 10px 8px;
}

.scan-history-table tbody td.domain-cell {
  word-break: break-all;
  overflow-wrap: anywhere;
  max-width: 320px;
  min-width: 180px;
}

.scan-history-table tbody tr:last-child td {
  border-bottom: none !important;
}

/* Risk Score badges */
.top5-table__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.06px;
  white-space: nowrap;
}

.top5-table__badge--high {
  background: #D92D20;
  color: #fff;
}

.top5-table__badge--medium {
  background: #FDB022;
  color: #fff;
}

.top5-table__badge--low {
  background: #12B76A;
  color: #fff;
}

/* Domain Status badges */
.top5-table__badge--under-review {
  background: #FFF9F5;
  color: #ec911b;
}

.top5-table__badge--dismissed {
  background: #FAFAFA;
  color: #4B4B4B;
}

.top5-table__badge--watchlisted {
  background: #FFFBFA;
  color: #F04438;
}

/* Action buttons */
.top5-table__actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

.top5-table__btn {
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  box-shadow: 0 0 1.5px rgba(0, 0, 0, 0.1);
}

.top5-table__btn--watchlist {
  background: #267CE5;
  color: #fff;
}

.top5-table__btn--detail {
  background: #fff;
  color: #4b4b4b;
}

.top5-table__empty {
  padding: 16px 20px;
  font-size: 12px;
  color: #9f9f9f;
  text-align: center;
}
</style>
